import React from 'react';
import { BottomSheet, Button } from 'components';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: any;
  message?: any;
  confirmLabel?: any;
  loading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={title || t('common.confirmDeleteTitle')}
      description={message || t('common.confirmDeleteMessage')}
      footer={
        <div className="flex flex-col-reverse md:flex-row md:justify-end gap-[12px]">
          <Button
            label={t('common.cancel')}
            onClick={onClose}
            color="#828E9F"
            fullWidth
          />
          <Button
            label={confirmLabel || t('common.delete')}
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
            fullWidth
          />
        </div>
      }
    />
  );
};
